import { render, staticRenderFns } from "./OurServiceCard.vue?vue&type=template&id=63aa0859&scoped=true"
import script from "./OurServiceCard.vue?vue&type=script&lang=js"
export * from "./OurServiceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa0859",
  null
  
)

export default component.exports